import * as graphql from '@attain-apps/fe/web/main/lib/graphql'

import * as records from '../../../records'
import type { Filters } from '../../types'

/**
 * Only the organization is sent: the query itself scopes the payrolls to the
 * unassigned sponsored ones
 */
export const TRANSFORMER = graphql.transformers.IN.object<
  Filters,
  graphql.schema.SpacePayrollsFilterInput
>(
  {
    organizationFilter: {
      usingFullInput: graphql.transformers.IN.select(
        'orgFilter',
        records.gql.inputs.dimensionFilter.TRANSFORMER,
      ),
    },
  },
  { onNullish: null },
)
